/*
 * @providesModule SignUpStyle
 */

import {StyleSheet, Dimensions, Platform} from 'react-native';
import Sizes from 'Sizes';

const backgroundWidth = Dimensions.get('screen').width * 1.3;
const backgroundHeightDivider = Sizes.isTablet() ? 3.78 : Platform.OS == 'ios' ? 3.2 : 2.45;
const buttonWidth = Sizes.isTablet() ? 374 : 311;
const regularFontSize = Sizes.isTablet() ? 19 : 16;
const regularLineHeight = Sizes.isTablet() ? 28 : 20;
let backgroundHeight = Dimensions.get('screen').height / backgroundHeightDivider;
if (backgroundHeight < 250) {
  backgroundHeight = 256;
}

export default StyleSheet.create({
  headerContainer: {
    width: '100%',
    borderBottomColor: 'rgba(0, 0, 0, 0.2)',
    borderBottomWidth: 1,
    justifyContent: 'center',
  },

  backgroundContainer: {
    marginTop: 16,
  },

  background: {
    width: backgroundWidth,
    height: backgroundHeight,
    alignSelf: 'center',
    position: 'absolute',
    marginTop: 0,
  },

  saveAccountContainer: {
    alignSelf: 'center',
    marginLeft: Sizes.isTablet() ? -25 : -18,
    flexDirection: 'row',
    marginTop: 36,
    marginBottom: 16,
    alignItems: 'flex-end',
  },

  saveAccountIconContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: Sizes.isTablet() ? 25 : 18,
    alignItems: 'center',
  },

  imageText: {
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    fontSize: Sizes.isTablet() ? 14 : 12,
    color: 'rgba(0, 0, 0, 0.9)',
  },

  container: {
    alignItems: 'center',
    backgroundColor: '#ffffff',
    height: '100%',
    ...Platform.select({
      web: {
        width: '100%',
      },
    }),
  },

  leftIconContainer: {
    height: 23,
  },

  leftIcon: {
    height: 23,
    width: 23,
    top: 3,
  },

  rightIcon: {
    height: 23,
    width: 23,
  },

  helpModalContainer: {
    paddingHorizontal: 32,
    alignItems: 'center',
    width: '100%',
  },
  helpModalBody: {
    color: 'rgba(0, 0, 0, 0.9)',
    fontSize: 16,
    lineHeight: 24,
    fontWeight: '400',
    fontStyle: 'normal',
    fontFamily: 'OpenSans-Regular',
    marginTop: 16,
    marginBottom: 32,
    width: '100%',
  },
  helpModalTitle: {
    fontFamily: 'OpenSans-Bold',
    fontStyle: 'normal',
    fontWeight: Platform.OS !== 'ios' ? 'bold' : '700',
    fontSize: 20,
    lineHeight: 28,
    color: '#000',
    textAlign: 'left',
    width: '100%',
    marginTop: 32,
  },

  rewardsIcon: {
    width: Sizes.isTablet() ? 48 : 40,
    height: Sizes.isTablet() ? 42 : 35,
    marginBottom: Sizes.isTablet() ? 4 : 6.44,
  },

  customerSupportIcon: {
    width: Sizes.isTablet() ? 56 : 46,
    height: Sizes.isTablet() ? 45 : 36,
    marginBottom: Sizes.isTablet() ? 3 : 6,
  },

  ribbonIcon: {
    width: Sizes.isTablet() ? 46 : 38,
    height: Sizes.isTablet() ? 56 : 47,
    marginBottom: Sizes.isTablet() ? 0 : 0.84,
  },
});
